const titles = {
  manager: {
    attendances: 'Absences',
    audit: 'Audit',
    availabilities: 'Disponibilités',
    bulletins: 'Babillard',
    contactLists: 'Listes de contact',
    punchCards: 'Cartes de temps',
    projects: 'Projets',
    schedule: 'Horaire',
    scheduleTemplates: `Modèles d'horaire`,
    timeOffs: 'Congés',
    reportsList: 'Rapports',
    userlist: 'Liste des utilisateurs',
    dashboard: 'Tableau de bord',
    users: 'Utilisateurs'
  },
  employee: {
    home: 'Accueil',
    attendances: 'Mes absences',
    attendance: 'Mon absence',
    schedule: 'Mon horaire',
    timeoffs: 'Mes congés',
    timeoff: 'Mon congé',
    messages: 'Mes messages',
    availabilities: 'Mes disponibilités',
    availability: 'Ma disponibilité',
    settings: 'Mes réglages',
    shiftOffers: 'Mes offres de travail',
    profile: 'Mon profil',
    notifications: 'Mes notifications',
    notFound: 'Introuvable'
  },
  admin: {
    settings: `Paramètres de l'application`,
    defaultConfig: 'Filtres par défaut',
    defaultFilterConfig: 'Filtres',
    listConfig: 'Types de listes',
    permissions: 'Permissions',
    procedureConfig: 'Procédures des listes',
    sortConfig: 'Classements',
    breaks: 'Pauses',
    wagePremiums: 'Codes de primes',
    punchRules: 'Règles des cartes de temps',
    requestOptions: 'Types de requêtes',
    positions: 'Positions',
    structures: 'Structure',
    scheduleTypes: `Types d'horaires`,
    tags: 'Étiquettes',
    holidays: 'Jours fériés',
    attributes: 'Attributs',
    hiringData: `Données d'embauche`,
    teams: 'Équipes',
    departments: 'Départements'
  }
}

export default titles
